export function isTrialGateway(model?: string | null) {
  return model === 'Lumeo Cloud Trial';
}
